const n = "_container_mvylb_1", o = "_loadingContainer_mvylb_8", e = "_videoPlayerContainer_mvylb_23", a = {
  container: n,
  loadingContainer: o,
  videoPlayerContainer: e
};
export {
  a as s
};
